import React, { PropTypes, Component ,PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../../../../src/components/common/loading';

 export default class ProgressIconPage extends Component {
  render() {
  	return(
	  	<div>
	  		<LoadingCircle isPage={true}/>
	  	</div>
  		);
  }
}
